import React, { useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import { formatDate } from "../../../helpers/formatDate";

export default function SimpleMap({ locations }) {
  const customIcon = new L.Icon({
    iconUrl:
      "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  const polylinePositions = locations?.map((loc) => [
    loc?.location.latitude,
    loc?.location.longitude,
  ]);

  function AutofocusMap() {
    const map = useMap();

    useEffect(() => {
      if (locations?.length > 0) {
        const bounds = L.latLngBounds(polylinePositions);
        map.fitBounds(bounds, { padding: [50, 50] });
      }
    }, [locations, map]);

    return null;
  }

  return (
    <MapContainer
      center={[20.5937, 78.9629]}
      zoom={5}
      style={{ height: "100%", width: "100%" }}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <AutofocusMap />

      {locations?.length > 0 && (
        <>
          {/* First Marker */}
          <Marker
            icon={customIcon}
            position={[locations[0].location.latitude, locations[0].location.longitude]}
          >
            <Popup>
              <div>
                <strong>Location: </strong>
                {locations[0].location.latitude}, {locations[0].location.longitude}
                {locations[0]?.timestamp && (
                  <span>
                    ⏰ <strong>Last Update:</strong> {formatDate(locations[0]?.timestamp)}
                  </span>
                )}
              </div>
            </Popup>
          </Marker>

          {/* Last Marker */}
          {locations.length > 1 && (
            <Marker
              icon={customIcon}
              position={[
                locations[locations.length - 1].location.latitude,
                locations[locations.length - 1].location.longitude,
              ]}
            >
              <Popup>
                <div>
                  <strong>Location: </strong>
                  {locations[locations.length - 1].location.latitude}, {locations[locations.length - 1].location.longitude}
                  {locations[locations.length - 1]?.timestamp && (
                    <span>
                      ⏰ <strong>Last Update:</strong> {formatDate(locations[locations.length - 1]?.timestamp)}
                    </span>
                  )}
                </div>
              </Popup>
            </Marker>
          )}
        </>
      )}

      {polylinePositions?.length > 1 && (
        <Polyline positions={polylinePositions} color="blue" />
      )}
    </MapContainer>
  );
}
